import type { Resource } from '../../';
export const country_countries_AU: Resource = {"default":"Australia"};
